module.exports = __webpack_public_path__ + "static/img/RAC168M_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAC168M_1.png
// module id = 30/l
// module chunks = 0